import Reveal from "@/components/Reveal";
import { Linkedin, Instagram, Facebook, Globe } from "lucide-react";
import site from "@/config/site";

const Founder = () => {
  const socials = [
    { icon: Linkedin, url: site.social.linkedin, label: "LinkedIn", testid: "social-link-linkedin" },
    { icon: Instagram, url: site.social.instagram, label: "Instagram", testid: "social-link-instagram" },
    { icon: Facebook, url: site.social.facebook, label: "Facebook", testid: "social-link-facebook" },
  ].filter((s) => s.url);

  return (
    <section data-testid="founder-section" className="relative max-w-7xl mx-auto px-5 sm:px-8 py-24 sm:py-36">
      <div className="grid lg:grid-cols-[1fr_1.2fr] gap-14 items-center">
        <Reveal>
          <div className="relative max-w-md mx-auto lg:mx-0">
            <div className="absolute -inset-5 rounded-[2rem] bg-[var(--accent)]/20 blur-3xl pointer-events-none" />
            <div className="spotlight-frame">
              <div className="overflow-hidden rounded-[1.5rem] border border-[#27331C]">
                <img
                  src={site.images.founderPoster}
                  alt="Deepankshi Saxena — Founder, Sanvalio & Design4You"
                  data-testid="founder-photo"
                  className="w-full aspect-square object-cover grayscale-[15%]"
                />
              </div>
            </div>
            <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full border border-[#27331C] bg-[#0A0F08] px-6 py-3 shadow-2xl">
              <span className="font-sans text-base font-bold tracking-wide text-[#F2F1E8]">Deepankshi Saxena</span>
              <span className="ml-2 font-mono2 text-xs text-[#8A8C7E]">· FOUNDER</span>
            </div>
          </div>
        </Reveal>
        <div>
          <Reveal>
            <div className="flex items-baseline gap-4 mb-6">
              <span className="font-mono2 text-xs tracking-[0.3em] text-[var(--accent)]">05</span>
              <span className="h-px flex-1 bg-[#27331C]" />
              <span className="font-mono2 text-xs tracking-[0.3em] text-[#8A8C7E]">THE FOUNDER</span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#F2F1E8]">
              You don't need to look<br />
              like <span className="italic font-light text-[var(--accent)]">everyone else.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.12}>
            <p className="mt-7 text-sm sm:text-base text-[#B9BBAC] leading-relaxed max-w-xl">
              I'm <span className="text-[#F2F1E8] font-semibold">Deepankshi Saxena</span> — the founder behind{" "}
              <span className="text-[#F2F1E8] font-semibold">Sanvalio</span> and{" "}
              <span className="text-[#F2F1E8] font-semibold">Design4You</span>. Since 2015, I've worked with{" "}
              <span className="text-[var(--accent)] font-semibold">5000+ brands</span> and delivered{" "}
              <span className="text-[var(--accent)] font-semibold">20,000+ projects</span> across the globe — all built on one belief:
              strategy first, design with purpose, growth that compounds. I work with a small number of
              founders at a time, personally. No account managers, no templates — just honest diagnosis
              and execution that moves numbers.
            </p>
            <p className="mt-4 font-mono2 text-xs tracking-[0.2em] text-[#E4B54A]">{site.founder.toUpperCase()}</p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-8 flex flex-wrap items-center gap-3">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={s.testid}
                  aria-label={s.label}
                  className="flex items-center gap-2 border border-[#27331C] rounded-full px-5 py-2.5 text-sm text-[#B9BBAC] hover:border-[var(--accent)] hover:text-[var(--accent)] transition-colors duration-300"
                >
                  <s.icon className="w-4 h-4" />
                  {s.label}
                </a>
              ))}
              <a
                href={site.social.sanvalio}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-link-sanvalio"
                className="flex items-center gap-2 border border-[#27331C] rounded-full px-5 py-2.5 text-sm text-[#B9BBAC] hover:border-[var(--accent)] hover:text-[var(--accent)] transition-colors duration-300"
              >
                <Globe className="w-4 h-4" /> sanvalio.com
              </a>
              <a
                href={site.social.design4you}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-link-design4you"
                className="flex items-center gap-2 border border-[#27331C] rounded-full px-5 py-2.5 text-sm text-[#B9BBAC] hover:border-[var(--accent)] hover:text-[var(--accent)] transition-colors duration-300"
              >
                <Globe className="w-4 h-4" /> design4you.co.in
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Founder;
